module.exports = __webpack_public_path__ + "static/media/gladiator-4row.62603afc.png";